const NEW_USER = "new-user";
const REGISTERED_USER = "registered-user";
const WALLET_NOT_REGISTERED = "wallet-not-registered";

export const WALLET_LOGIN_RESPONSE_STATUS = {
  NEW_USER,
  REGISTERED_USER,
  WALLET_NOT_REGISTERED,
};
